import React, {useEffect} from "react"
import {Container, Divider, Header} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import {connect, useDispatch} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {setIsMember} from "../actions/initialDataActions";
import Footer from "./footer";
import {checkIsVerified, isDistributionChannelIndividual, isRenaissance} from "../utils/common";
import moment from "moment";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import useLockNavigation from "../hooks/useLockNavigation";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        name: user.firstName,
        lang: user.lang,
        initialData, benAdmin,
        user,
        effectiveDate: initialData.coverageEffectiveDate,
    }
};

const Success = (props) => {
    const {name, lang, initialData, effectiveDate, user, benAdmin} = props;
    const localization = getLocalization(lang);
    const isIndividual = isDistributionChannelIndividual(initialData.distributionChannel);
    const strings = isIndividual ? localization.individualSuccess : localization.success;
    const dispatch = useDispatch();
    useLockNavigation();

    useEffect(() => {
        dispatch(setPrevRoute(props.prevRoute));
        if(!isIndividual && !initialData.isMember) {
            dispatch(setIsMember(true));
        }
        checkIsVerified(user, benAdmin, initialData.uiFlow, props, initialData.distributionChannel);
    },[benAdmin, dispatch, initialData.isMember, initialData.uiFlow, initialData.distributionChannel, isIndividual, props, user]);

    if (isIndividual) {
        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <CustomGrid container stackable columns={1} centered fitted={'horizontally'}>
                        <CustomGrid.Column style={{marginTop: '1rem'}} width={8}>
                            <CustomGrid stackable container textAlign={'left'}>
                                <CustomGrid.Row columns={1}>
                                    <CustomGrid.Column>
                                        <S3Image {...IMAGE.THANK_YOU} style={{marginBottom: '40px'}}/>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column textAlign={"center"}>
                                        <Header as='h1'>{strings.title}</Header>
                                        <p>{parseMultilineString(strings.description)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData
                    buttonText={strings.goToEnrollment}
                    disabled={!initialData.enrollmentPlatformLink}
                    onClickCallback={() => window.location.assign(initialData.enrollmentPlatformLink)}
                />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Container className={'contentContainer'}>
                <CustomGrid container stackable columns={1} centered fitted={'horizontally'}>
                    <CustomGrid.Column style={{marginTop: '1rem'}} width={8}>
                        <CustomGrid stackable container textAlign={'left'}>
                            <CustomGrid.Row columns={1}>
                                <CustomGrid.Column>
                                    <S3Image {...IMAGE.THANK_YOU} style={{marginBottom: '40px'}}/>
                                </CustomGrid.Column>
                                <CustomGrid.Column textAlign={"center"}>
                                    <Header as='h1'>{interpolateString(strings.title, [name])}</Header>
                                    <p className={isRenaissance() && "successDescriptionText"}>{strings.description}</p>
                                    <p><b>{strings.yourCoverage} {moment(effectiveDate).format("MMM DD, YYYY")}</b></p>
                                    <p>{parseMultilineString(strings.next)}</p>
                                </CustomGrid.Column>
                                <CustomGrid.Column textAlign={"center"}>
                                    <Divider hidden/>
                                    <Header as='h4' style={{marginBottom: '.5em'}}>{strings.allDone}</Header>
                                    <p>{strings.feelFree} <a href={initialData.hostname + '/member'}>{strings.logOut}</a></p>
                                </CustomGrid.Column>
                            </CustomGrid.Row>
                        </CustomGrid>
                    </CustomGrid.Column>
                </CustomGrid>
            </Container>
            <Footer showTopFooter={false} showCenterData/>
        </React.Fragment>
    )
    }

export default withRouter(connect(mapStateToProps)(Success));
